import React from 'react'
import { IconButton } from '@mui/material'
import { styled } from '@mui/system'

import LastPage from '@mui/icons-material/LastPage'
import FirstPage from '@mui/icons-material/FirstPage'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'

import { textColors } from '../Color/Color'
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions' // Import the correct types

const StyledIconButton = styled(IconButton)(() => ({
  color: textColors.greenAccessible,
}))

const TablePaginationActions: React.FC<TablePaginationActionsProps> = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
}) => {
  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
  }

  return (
    <div style={{ flexShrink: 0, marginLeft: window.innerWidth < 600 ? '0.25rem' : '2.5rem' }}>
      <StyledIconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label='first page'
        id='go-to-first-page-button'
      >
        <FirstPage />
      </StyledIconButton>
      <StyledIconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label='previous page'
        id='go-to-previos-page-button'
      >
        <KeyboardArrowLeftIcon />
      </StyledIconButton>
      <StyledIconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='next page'
        id='go-to-next-page-button'
      >
        <KeyboardArrowRightIcon />
      </StyledIconButton>
      <StyledIconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='last page'
        id='go-to-last-page-button'
      >
        <LastPage />
      </StyledIconButton>
    </div>
  )
}

export default TablePaginationActions
